import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BotonAyuda from './BotonAyuda';

// Pantalla que agrupa varias páginas en pestañas (docs/ESTANDAR-UI.md).
// Cada pestaña conserva su propia ruta, así los enlaces existentes siguen
// andando; la página embebida recibe `embebido` para no repetir su <h1>.
export default function PantallaPestanas({ titulo, pestanas }) {
  const { empresaActiva, empresas } = useAuth();
  const empresaNombre = empresas.find((e) => String(e.empresa_id) === String(empresaActiva))?.empresa_nombre;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const activa = pestanas.find((p) => pathname === p.ruta) || pestanas[0];
  const Pagina = activa.componente;

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-slate-800 print:hidden">
        {titulo}
        {empresaNombre && <span className="text-slate-400 font-normal"> · {empresaNombre}</span>}
        <BotonAyuda />
      </h1>

      <div className="flex gap-1 border-b print:hidden">
        {pestanas.map((p) => (
          <button
            key={p.ruta}
            onClick={() => navigate(p.ruta)}
            className={`px-3.5 py-2.5 text-sm ${activa.ruta === p.ruta ? 'font-semibold text-primary-600 border-b-2 border-primary-600' : 'text-slate-500 hover:text-slate-700'}`}
          >
            {p.label}
          </button>
        ))}
      </div>

      <Pagina embebido />
    </div>
  );
}
